import { Injectable, inject } from '@angular/core';
import {BehaviorSubject, Observable, skipWhile} from 'rxjs';
import {Department} from '../master-data/master-data.model';
import {API_URL} from '../../environments/environment';
import { HttpClient, HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DepartmentsService {
  private http = inject(HttpClient);

  private departmentsBS$: BehaviorSubject<Department[] | null> = new BehaviorSubject(null);
  departments$: Observable<Department[] | null> = this.departmentsBS$.asObservable();

  constructor() {
    this.getDepartments();
  }

  getDepartments() {
    this.http.get<Department[]>(API_URL + 'department')
      .pipe(
        skipWhile((dps) => dps == null)
      ).subscribe((depts) => {
      this.departmentsBS$.next(depts);
    });
  }

  updateDepartment(department): Observable<HttpResponse<Department>> {
    console.log('Update department', department);
    return this.http.post<Department>(API_URL + 'department', department, {
      observe: 'response'
    });
  }

}
